import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { OpportunityDiaryNoteDetailsComponent } from '../details/opportunity-diary-note-details.component';
import { DiaryNote } from '@features/diary-notes/model/diary-note';
import { DiaryNoteService } from '@features/diary-notes/services/diary-note.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-opportunity-diary-note-edit',
  templateUrl: '../details/opportunity-diary-note-details.component.html'
})
export class OpportunityDiaryNoteEditComponent
  extends OpportunityDiaryNoteDetailsComponent
  implements OnInit
{
  get isNewDiaryNote(): boolean {
    return false;
  }

  constructor(
    oppDiaryNoteService: DiaryNoteService,
    protected fb: FormBuilder
  ) {
    super(oppDiaryNoteService, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  get saveLabel(): string {
    return 'Save';
  }

  get title(): string {
    return 'Edit Diary Note';
  }

  get showAssignTo(): boolean {
    return false;
  }

  content(): Observable<DiaryNote.Model> {
    return this.oppDiaryNoteService.getDiaryNoteForEdit(
      this.entityId,
      this.diaryNoteId
    );
  }
}
